import { render, staticRenderFns } from "./casestudy_ello.vue?vue&type=template&id=1d8b836e&scoped=true"
import script from "./casestudy_ello.vue?vue&type=script&lang=js"
export * from "./casestudy_ello.vue?vue&type=script&lang=js"
import style0 from "./casestudy_ello.vue?vue&type=style&index=0&id=1d8b836e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b836e",
  null
  
)

export default component.exports